import { callIntervalEntityName, messageTypeEntityName, repeatCallEntityName } from '../../../backend/config/classifiers';
import { CallIntervalAdminPage } from './CallIntervalAdminPage';
import { MessageTypeAdminPage } from './MessageTypeAdminPage';
import { RepeatCallAdminPage } from './RepeatCallAdminPage';
export const alertUiAdminPages = [
    {
        label: 'Call Interval',
        name: callIntervalEntityName,
        path: 'call-interval',
        groupLabel: 'Notifications',
        component: CallIntervalAdminPage,
    },
    {
        label: 'Message Type',
        name: messageTypeEntityName,
        path: 'message-type',
        groupLabel: 'Notifications',
        component: MessageTypeAdminPage,
    },
    {
        label: 'Repeat Call',
        name: repeatCallEntityName,
        path: 'repeat-call',
        groupLabel: 'Notifications',
        component: RepeatCallAdminPage,
    },
];
